import React from 'react'

function Input({ variant = "normal", label, type = "text", ...rest }) {
    if (variant === "complex") {
        return (
            <input
                {...rest}
                type={type}
                className='text-xs px-5 py-3 outline-none bottom-3 transition-all delay-200 bg-white
                bg-slate-50/10 w-full rounded-lg !border !border-gray-300 ring-[3px] focus:!border-gray-900 
                focus-within:ring-gray-800/10 ring-transparent shadow-lg shadow-gray-900/5 '
            />
        )
    } else {
        return (
            <div className="space-y-2">
                <input
                    {...rest}
                    type={type}
                    className='w-full border border-gray-300 px-4 py-3 text-xs rounded-lg
                outline-none focus:border-black/20 placeholder:text-gray-400'
                />
            </div>
        )
    }
}

export default Input